module.exports = __webpack_public_path__ + "img/cocktail.1ef0e986.png";